import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { checkHttpStatus, parseJSON } from '../../utils';
import './styles.scss';

const propTypes = {
  statusText: PropTypes.string,
  sectionName: PropTypes.string,
  userName: PropTypes.string,
  profileImage: PropTypes.string
};

const defaultProps = {
  sectionName: '',
  statusText: '',
  userName: '',
  profileImage: 'https://explore.org/images/icon_avatar_default.png'
};

class TestimonialsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      testimonials: [],
    };
  }

  componentDidMount () {
    fetch(`${SERVER_URL}/testimonials`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        this.setState({ testimonials: response.data.testimonials })
      })
      .catch((error) => {
        console.log(error, 'An error occurred');
      });
  }

  componentDidUpdate () {}

  renderTestimonials() {
    let testimonials = this.state.testimonials;
    return testimonials.map((testimonial, index) => {
      return (
        <div className="testimonial mx-auto u-textSize-18" key={index}>
          <div className="quote u-font-foundation-light">
            &#34;{testimonial.description}&#34;
          </div>
          <div className="attribution text-right">
              <div className="u-font-foundation-bold">
                { testimonial.gallery_url ? (
                    <a href={testimonial.gallery_url} target="_blank">{testimonial.author}</a>
                  ) : (
                    testimonial.author
                )}
              </div>
            { testimonial.organization &&
              <div>
                {testimonial.organization_url ? (
                  <a href={testimonial.organization_url} target="_blank">{testimonial.organization}</a>
                ): (
                  testimonial.organization
                )}
              </div>
            }
          </div>
        </div>
      );
    })
  }

  render() {
    return (
        <div className="container-fluid content static-page bg-fff-65">
          <div className="row">
            <div className="col-sm-12 pr-35 pl-35">
              <h1 className="">testimonials</h1>
              <div className="float-md-right mb-2 ml-2 text-center">
                <div className="embed-responsive embed-responsive-16by9 testimonial-video">
                  <iframe
                    className="embed-responsive-item"
                    title="Explore Viewer Testimonials"
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/NWjeLqXs4Yc?rel=0&showinfo=0&autoplay=1&playsinline=1"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen=""
                  />
                </div>
              </div>
              <p className="u-textSize-20 my-20">
                Explore’s mission is to bring people closer to nature and to champion
                the selfless acts of others - and so we’d love to thank our wonderful
                community of live cam viewers, commenters, and camera operators for
                your contributions, taking part in our online neighborhood, learning
                alongside us, and for sharing so many kinds words about explore. You
                are the heart and soul of our organization! Here is what our fans
                are saying:
              </p>
              {this.renderTestimonials()}
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userName: state.auth.userName,
    statusText: state.auth.statusText,
    previousPath: state.globalConfig.previousPath,
  };
};

TestimonialsView.propTypes = propTypes;
TestimonialsView.defaultProps = defaultProps;

export default connect(mapStateToProps)(TestimonialsView);
